import { FC, useState, useEffect } from 'react';
import styled from './index.module.scss';
import Coupon from './Coupon';
import { useGlobal } from '@/utils/useGlobal';
import { ICouponDetail, ShareType } from '@/components/Ambassador/index.d';
import { ArrowIcon } from '@/components/UI/svg/Referral';
import { getPageRewards } from '@/service/referral';

const filterNum = 3;
const Rewards: FC = ({}) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const [filterList, setFilterList] = useState<ICouponDetail[]>([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        getPageRewards(
            {
                shareType: ShareType.RECEIVER,
                size: -1,
            },
            locale,
        ).then((res) => {
            setFilterList(res.data.content);
        });
    }, []);

    if (!filterList || filterList.length === 0) return <></>;

    return (
        <div className={`${styled.rewards}`}>
            <h3 className="title">{t('rewards.title')}</h3>
            <div className="coupon_box">
                {filterList
                    ?.filter((_item, index) => (showAll ? true : index < filterNum))
                    .map((item, index) => (
                        <Coupon key={index} coupon={item} />
                    ))}
            </div>
            {filterList && filterList.length > filterNum && (
                <div className={`view_more ${showAll ? 'view_less' : ''}`} onClick={() => setShowAll(!showAll)}>
                    {showAll ? t('view_less') : t('view_more')}
                    <ArrowIcon />
                </div>
            )}
        </div>
    );
};

export default Rewards;
